import React, { FC, ReactNode } from 'react';
import COEYearDateRangeComponent from '../../../../components/coe-date-range/coe-year-date-range.component';
import { useTrainingLogContext } from '../../training-log.context';
import './training-log-page-header.component.css';

export interface TrainingLogPageHeaderProps {
  title: string;
  subtitle: ReactNode;
  showSeasonDateRange?: boolean;
  className?: string;
}

const TrainingLogPageHeader: FC<TrainingLogPageHeaderProps> = ({
  title,
  subtitle,
  showSeasonDateRange = false,
  className,
}) => {
  const { seasonLabel, seasonStart, setSeasonStart } = useTrainingLogContext();

  const rootClassName = ['training-log-page-header', className].filter(Boolean).join(' ');

  return (
    <div className={rootClassName}>
      <div>
        <div className="training-log-page-header-breadcrumb">{seasonLabel}</div>
        <h1 className="training-log-page-header-title">{title}</h1>
        <p className="training-log-page-header-subtitle">{subtitle}</p>
      </div>
      {showSeasonDateRange && seasonStart && (
        <div className="training-log-page-header-actions">
          <COEYearDateRangeComponent value={seasonStart} setValue={setSeasonStart} />
        </div>
      )}
    </div>
  );
};

export default TrainingLogPageHeader;
